
(function () {
  'use strict';

  function initInfiniteScroll() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var productList = grid.querySelector('ul.product-grid');
    if (!productList) return;

    var paginationEl = grid.querySelector('.pagination__list, nav[role="navigation"], .pagination');
    var nextLink = paginationEl ? paginationEl.querySelector('a[aria-label*="Next"], a[rel="next"], .pagination__item--next a, a:last-child') : null;

    if (!nextLink || !nextLink.href) {
      if (paginationEl) paginationEl.style.display = 'none';
      return;
    }

    // Ocultar paginación original
    if (paginationEl) paginationEl.style.display = 'none';

    // Crear sentinel + spinner
    var sentinel = document.createElement('div');
    sentinel.id  = 'alco-scroll-sentinel';
    sentinel.setAttribute('data-next-url', nextLink.href);
    sentinel.style.cssText = 'height:1px;margin-top:40px;';
    grid.appendChild(sentinel);

    var spinner = document.createElement('div');
    spinner.id  = 'alco-scroll-spinner';
    spinner.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;padding:2rem;gap:10px;color:#1b1464;font-size:14px;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1b1464" stroke-width="2" style="animation:alco-spin 0.8s linear infinite"><circle cx="12" cy="12" r="10" stroke-opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10"/></svg>Cargando más productos...</div>';
    spinner.style.display = 'none';
    grid.appendChild(spinner);

    // Inyectar keyframes si no existen
    if (!document.getElementById('alco-spin-style')) {
      var st = document.createElement('style');
      st.id  = 'alco-spin-style';
      st.textContent = '@keyframes alco-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }

    var loading  = false;
    var exhausted = false;

    function loadMore() {
      if (loading || exhausted) return;
      var nextUrl = sentinel.getAttribute('data-next-url');
      if (!nextUrl) { exhausted = true; return; }

      loading = true;
      spinner.style.display = 'block';

      fetch(nextUrl)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          if (!newGrid) { exhausted = true; return; }

          // Añadir nuevos artículos
          var newItems = newGrid.querySelectorAll('ul.product-grid > li');
          newItems.forEach(function(li) {
            productList.appendChild(li.cloneNode(true));
          });

          // Buscar próxima página
          var newPag     = newGrid.querySelector('.pagination__list, nav[role="navigation"], .pagination');
          var newNextLink = newPag ? newPag.querySelector('a[aria-label*="Next"], a[rel="next"], .pagination__item--next a, a:last-child') : null;

          if (newNextLink && newNextLink.href && newNextLink.href !== nextUrl) {
            sentinel.setAttribute('data-next-url', newNextLink.href);
          } else {
            exhausted = true;
            sentinel.remove();
          }

          // Reinicializar lazy-load de imágenes Shopify si existe
          if (window.Shopify && window.Shopify.loadFeatures) {
            document.querySelectorAll('[data-srcset]').forEach(function(img) {
              if (!img.src || img.src.indexOf('blank') > -1) {
                img.src = img.getAttribute('data-srcset').split(' ')[0];
              }
            });
          }
        })
        .catch(function(err) {
          console.warn('ALCO infinite scroll error:', err);
          exhausted = true;
        })
        .finally(function() {
          loading = false;
          spinner.style.display = 'none';
        });
    }

    // IntersectionObserver — dispara 400px antes del sentinel
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) loadMore();
      });
    }, { rootMargin: '0px 0px 400px 0px', threshold: 0 });

    observer.observe(sentinel);
  }

  // Inicializar al cargar + después de filtros Shopify
  document.addEventListener('DOMContentLoaded', initInfiniteScroll);

  // Re-init cuando Shopify actualiza la URL por filtros (facets)
  document.addEventListener('shopify:section:load', initInfiniteScroll);

  // Observer para cuando el grid se re-renderiza (filtros AJAX de Dawn)
  var pageObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.id === 'product-grid' || (node.querySelector && node.querySelector('#product-grid'))) {
          setTimeout(initInfiniteScroll, 100);
        }
      });
    });
  });
  pageObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });

})();
